<template>
  <AppCarousel
    :breakpoints="{
      851: { itemsToShow: 1 },
      1250: { itemsToShow: 1, gap: 40 },
      1550: { itemsToShow: 1.3, gap: 40 },
      1800: { itemsToShow: 1.5, gap: 40 },
      1900: { itemsToShow: 1.62, gap: 40 },
      2000: { itemsToShow: 1.7, gap: 40 }
    }"
    wrap-around navigation
  >
    <AppCarouselSlide
      v-for="(products, country) in groupBy(products, p => p.country)"
      :key="country"
      class="slide pb-6 pt-2"
    >
      <CountriesOverviewCarouselCard
        :product="findCheapestProduct(products)"
        :bullets="BULLETS[country]"
      />
    </AppCarouselSlide>
  </AppCarousel>
</template>

<script setup lang="ts">
import { findCheapestProduct } from '~/helpers/product';
import type { CountryKey, Product } from '~/types';
import { AppCarousel } from '#components';
import { groupBy } from '~/helpers/general';

defineProps<{
  products: Product[];
}>();

const { tt } = useLocalization();
const BULLETS: Record<CountryKey, string[]> = {
  usa: [
    tt('page.pricing_card.valid_two_years_90_days_stay'),
    tt('page.pricing_card.approved_within_usa'),
    tt('page.pricing_card.no_embassy')
  ],
  india: [
    tt('page.pricing_card.valid_for_30_days_90_days_1_year_stay'),
    tt('page.pricing_card.approved_within_india'),
    tt('page.pricing_card.no_embassy')
  ],
  korea: [
    tt('page.pricing_card.valid_two_years_90_days_stay'),
    tt('page.pricing_card.approved_within_korea'),
    tt('page.pricing_card.no_embassy')
  ],
  morocco: [
    tt('page.pricing_card.valid_for_180_days'),
    tt('page.pricing_card.approved_within_morocco'),
    tt('page.pricing_card.no_embassy')
  ],
  canada: [
    tt('page.pricing_card.valid_5_years_6_months_per_visit'),
    tt('page.pricing_card.approved_within_canada'),
    tt('page.pricing_card.no_embassy')
  ],
  vietnam: [
    tt('page.pricing_card.valid_for_30_days_or_more'),
    tt('page.pricing_card.approved_within_vietnam'),
    tt('page.pricing_card.no_embassy')
  ],
  sri_lanka: [
    tt('page.pricing_card.support'),
    tt('page.pricing_card.approved_within_sri_lanka'),
    tt('page.pricing_card.urgent_option')
  ],
  new_zealand: [
    tt('page.pricing_card.valid_2_years_90_days_per_visit'),
    tt('page.pricing_card.approved_within_new_zealand'),
    tt('page.pricing_card.no_embassy')
  ],
  cambodia: [
    tt('page.pricing_card.valid_for_30_days'),
    tt('page.pricing_card.approved_within_cambodia'),
    tt('page.pricing_card.no_embassy')
  ],
  israel: [
    tt('page.pricing_card.valid_for_3_months'),
    tt('page.pricing_card.approved_within_israel'),
    tt('page.pricing_card.no_embassy')
  ],
  saudi_arabia: [
    tt('page.pricing_card.valid_1_year_90_days_per_visit'),
    tt('page.pricing_card.approved_within_saudi_arabia'),
    tt('page.pricing_card.no_embassy')
  ],
  bahrain: [
    tt('page.pricing_card.valid_for_2_weeks_3_months_or_more'),
    tt('page.pricing_card.approved_within_bahrain'),
    tt('page.pricing_card.no_embassy')
  ],
  indonesia: [
    tt('page.pricing_card.valid_for_30_days'),
    tt('page.pricing_card.approved_within_indonesia'),
    tt('page.pricing_card.no_embassy')
  ],
  uk: [
    tt('page.pricing_card.valid_2_years'),
    tt('page.pricing_card.approved_within_uk'),
    tt('page.pricing_card.no_embassy')
  ],
  togo: [
    tt('page.pricing_card.valid_15_days_30_days_90_days'),
    tt('page.pricing_card.approved_within_togo'),
    tt('page.pricing_card.no_embassy')
  ],
  thailand: [
    tt('page.pricing_card.valid_3_months_6_months_5_years'),
    tt('page.pricing_card.approved_within_thailand'),
    tt('page.pricing_card.support')
  ],
  schengen: [
    tt('page.pricing_card.valid_for_90_days'),
    tt('page.pricing_card.approved_within_schengen'),
    tt('page.pricing_card.support')
  ],
};
</script>

<style scoped>
.btns-container .btn {
  color: rgb(var(--v-theme-primary));
}
.btns-container .btn:hover {
  box-shadow: none !important;
}

@media (max-width: 850px) {
  .end {
    padding-inline: 0;
  }
  .btns-container {
    margin-inline-end: var(--space-5) !important;
  }
  .slide {
    padding-top: var(--space-4) !important;
  }
}
</style>